export default "__VITE_ASSET__DubrXguL__"